import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { Shield, Zap, Globe, Lock } from 'lucide-react';
import { getTranslations } from '@/lib/i18n';

export default function AuthBrandPanel() {
  const t = getTranslations('en');

  const trustBadges = [
    { icon: Shield, text: t?.brand?.bankGradeEncryption },
    { icon: Zap, text: t?.brand?.instantTransfers },
    { icon: Globe, text: t?.brand?.currencies },
    { icon: Lock, text: t?.brand?.fcaRegulated },
  ];

  return (
    <div className="relative w-full flex flex-col justify-between p-10 xl:p-14 overflow-hidden bg-card border-r border-border">
      {/* Background glow effects */}
      <div className="absolute top-[-120px] left-[-80px] w-[500px] h-[500px] rounded-full opacity-[0.06] bg-primary blur-[120px] pointer-events-none" />
      <div className="absolute bottom-[-80px] right-[-60px] w-[400px] h-[400px] rounded-full opacity-[0.05] bg-accent blur-[100px] pointer-events-none" />
      {/* Logo */}
      <div className="flex items-center gap-3 relative z-10">
        <AppLogo size={40} />
      </div>
      {/* Hero content */}
      <div className="relative z-10 space-y-6">
        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20">
            <span className="w-1.5 h-1.5 rounded-full bg-primary live-dot" />
            <span className="text-xs font-semibold text-primary">{t?.brand?.fullyDigital}</span>
          </div>
          <h1 className="text-4xl xl:text-5xl font-bold text-foreground leading-tight text-balance">
            {t?.brand?.tagline}<br />
            <span className="text-primary">{t?.brand?.taglineHighlight}</span>
          </h1>
          <p className="text-base text-muted-foreground leading-relaxed max-w-sm">
            {t?.brand?.description}
          </p>
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 gap-3">
          {trustBadges?.map((badge) => (
            <div
              key={`trust-${badge?.text}`}
              className="flex items-center gap-2.5 p-3 rounded-xl bg-muted border border-border"
            >
              <badge.icon size={16} className="text-primary shrink-0" />
              <span className="text-xs font-medium text-foreground">{badge?.text}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom stats */}
      <div className="relative z-10 grid grid-cols-3 gap-4 pt-6 border-t border-border">
        {[
          { value: '2.4M+', label: t?.brand?.activeCustomers },
          { value: '€18B+', label: t?.brand?.processedMonthly },
          { value: '99.97%', label: t?.brand?.uptimeSla },
        ]?.map((stat) => (
          <div key={`stat-${stat?.label}`}>
            <p className="text-xl font-bold text-foreground tabular-nums">{stat?.value}</p>
            <p className="text-[11px] text-muted-foreground mt-0.5">{stat?.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}